<template>
  <div class="body">
    <Header />
    <!-- <Home v-if="allData?.photo" :obj="allData?.photo" id="home" /> -->
    <playback></playback>
    <Highlight v-if="allData?.highlight" :arr="allData.highlight" />
    <About v-if="allData?.about" :obj="allData.about" />
    <Agenda id="agenda" v-if="allData?.agenda" :arr="allData.agenda" />
     <Guest id="guest" />
    <Activity id="activity" v-if="allData?.activity" :arr="allData.activity" />
    <News id="news" />
    <Partner v-if="allData?.partner" :arr="allData.partner" />
    <Business />
  </div>
</template>

<script setup>
import { ref, onBeforeMount } from 'vue'
import { getRecruit } from '@/api/2024/index'

import Home from './isc/home.vue'
import Header from '@/components/common/2024/header.vue'
import playback from '@/components/2024/playback/playback.vue'
import Highlight from './isc/highlight.vue'
import About from './isc/about.vue'
import Agenda from './isc/agenda.vue'
import Guest from './isc/guest.vue'
import Activity from './isc/activity.vue'
import News from './isc/news.vue'
import Partner from './isc/partner.vue'
import Business from './isc/business.vue'
// import Lesson from './isc/lesson.vue'

// const allData = ref({
//   "photo": {
//     "pc": "https://p4.ssl.qhimg.com/t110b9a9301226dbcd09a90287d.png",
//     "mobile": "https://p4.ssl.qhimg.com/t110b9a930197a2db4939dde0e4.png"
//   },
//   "highlight": [
//     {
//       "title": "ISC升级ISC.AI",
//       "subTitle": "解锁“安全和AI”前瞻技术",
//       "info": "打造数字安全日（7.31）、人工智能日（8.1）两大主题日，聚拢全球安全和人工智能专家智库，分享行业前瞻趋势，为参会者提供深入了解前沿科技、获取实战经验、激发创新思维、构建行业网络、规划职业发展的全方位价值体验。",
//       "Img": "https://p4.ssl.qhimg.com/t110b9a9301e95e8d87aac532e7.png"
//     },
//     {
//       "title": "“百模”集结探索行业应用",
//       "info": "打造大模型集结盛宴，重点探索“安全大模型”如何重塑安全行业的同时，延伸探讨和展示人工智能大模型的创新技术，以及如何在金融、医疗、交通等关键行业中实现垂直应用，推动千行百业数智化转型。",
//       "Img": "https://p4.ssl.qhimg.com/t110b9a9301516a9dfbefabe675.png"
//     },
//     {
//       "title": "行业资源罗盘引领新商机",
//       "info": "聚拢安全和AI产业链上中下游生态伙伴，为参会者打造深度交流与合作的平台，促进行业资源整合与商业机会的发掘。三场创新沙盒大赛为创业者高效对接投资者、金融机构，加速项目孵化和资金流动。",
//       "Img": "https://p1.ssl.qhimg.com/t110b9a93010f2d7fbc11850d5c.png"
//     },
//     {
//       "title": "红人互动共享AI打卡地",
//       "info": "打造AI体验馆、ISC开讲啦、赛博文化街等网红打卡地，让参会者直观感受AI技术最新应用的同时，与红衣大叔周鸿祎等一众行业领袖和网络红人近距离互动，共享百万流量红利。",
//       "Img": "https://p1.ssl.qhimg.com/t110b9a93011239ac7ce77dd537.png"
//     }
//   ],
//   "about": {
//     "photo": "https://p0.ssl.qhimg.com/t11b673bcd6930b0fc91cc8328c.png",
//     "title": "ISC.AI 2024 全面升级开启“聚变元年\"",
//     "paraA": "ISC.AI 2024 第十二届互联网安全大会将于7月31日-8月1 日在北京国家会议中心盛大开幕。继ISC 2023 举办全球首场 Al数字安全峰会后,ISC 大会全面升级为ISC.AI 2024,致力成为 AI大模型浪潮下的拓局者,开启“聚变元年”。届时ISC.AI 2024 将深度聚焦安全和 AI两大领域打造集行业前瞻对话、高峰技术研讨、先进成果展示、创新孵化大赛、产业人才培训于一体的全球顶尖盛会。"
//   },
//   "agenda": [
//     {
//       "date": "07/31",
//       "title": "数字安全日",
//       "time": "09:00~18:00",
//       "info": [
//         {
//           "title": "全部",
//           "children": [
//             {
//               "time": "上午",
//               "detail": [
//                 {
//                   "title": "数字安全峰会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             },
//             {
//               "time": "下午",
//               "detail": [
//                 {
//                   "title": "数字安全生态大会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "寻找明星场景·赋能垂直领域 安全大模型创新发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "大模型重塑安全运营论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI+关键信息基础设施保护论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI时代下攻防对抗技术研究论坛（闭门）",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "漏洞生态与实战人才发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "大型企业数字化转型安全发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "数字安全创新沙盒",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           "title": "开幕式&主题峰会",
//           "children": [
//             {
//               "time": "上午",
//               "detail": [
//                 {
//                   "title": "人工智能峰会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             },
//             {
//               "time": "下午",
//               "detail": [
//                 {
//                   "title": "数字安全生态大会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           "title": "主题论坛",
//           "children": [
//             {
//               "time": "下午",
//               "detail": [
//                 {
//                   "title": "寻找明星场景·赋能垂直领域 安全大模型创新发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "大模型重塑安全运营论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI+关键信息基础设施保护论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI时代下攻防对抗技术研究论坛（闭门）",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "漏洞生态与实战人才发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "大型企业数字化转型安全发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "数字安全创新沙盒",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     {
//       "date": "08/01",
//       "title": "人工智能日",
//       "time": "09:00~18:00",
//       "info": [
//         {
//           "title": "全部",
//           "children": [
//             {
//               "time": "上午",
//               "detail": [
//                 {
//                   "title": "人工智能-未来峰会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "企业安全运营与策略实践论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "新型涉网犯罪打击与治理论坛（闭门）",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "高级威胁狩猎分析论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "第二届全国信息安全产教融合发展大会暨全国信息安全行业产教融合共同体2024年年会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "守护数据价值：数据安全与创新应用论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "移动智能业务安全技术论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             },
//             {
//               "time": "下午",
//               "detail": [
//                 {
//                   "title": "人工智能生态大会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "全面融入·赋能未来 人工智能发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "数转智改驱动行业创新变革论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "未来行业与大模型融合论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "多模态时代的大模型关键技术与应用论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI的场景落地实践探讨论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "人工智能安全趋势发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI创新沙盒",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           "title": "主题峰会",
//           "children": [
//             {
//               "time": "上午",
//               "detail": [
//                 {
//                   "title": "人工智能-未来峰会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             },
//             {
//               "time": "下午",
//               "detail": [
//                 {
//                   "title": "人工智能生态大会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             }
//           ]
//         },
//         {
//           "title": "主题论坛",
//           "children": [
//             {
//               "time": "上午",
//               "detail": [
//                 {
//                   "title": "企业安全运营与策略实践论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "新型涉网犯罪打击与治理论坛（闭门）",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "高级威胁狩猎分析论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "第二届全国信息安全产教融合发展大会暨全国信息安全行业产教融合共同体2024年年会",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "守护数据价值：数据安全与创新应用论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "移动智能业务安全技术论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             },
//             {
//               "time": "下午",
//               "detail": [
//                 {
//                   "title": "全面融入·赋能未来 人工智能发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "数转智改驱动行业创新变革论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "未来行业与大模型融合论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "多模态时代的大模型关键技术与应用论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI的场景落地实践探讨论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "人工智能安全趋势发展论坛",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 },
//                 {
//                   "title": "AI创新沙盒",
//                   "place": "北京 · 国家会议中心",
//                   "path": ""
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     },
//     {
//       "date": "08/02",
//       "title": "ISC.AI 2024 上海站",
//       "time": "14:00~17:00",
//       "info": [
//         {
//           "title": "主题峰会",
//           "children": [
//             {
//               "time": "下午",
//               "detail": [
//                 {
//                   "title": "ISC.AI 2024 上海峰会",
//                   "place": "上海 · 中以(上海)创新园会议中心",
//                   "path": ""
//                 }
//               ]
//             }
//           ]
//         }
//       ]
//     }
//   ],
//   "activity": [
//     {
//       "id": 0,
//       "pcPhoto": "https://p4.ssl.qhimg.com/t110b9a9301dd3cb249461799bc.png",
//       "mobilePhoto": "https://p0.ssl.qhimg.com/t110b9a93015f11da76d5314521.png",
//       "title": "ISC训练营",
//       "detail": "ISC训练营将于7月30日在北京开营，为广大数字安全与人工智能从业人员提供顶尖的学习平台和宝贵的学习机会，汇集行业顶级师资，兼顾实战强化和学习社交，致力于培养未来的数字安全与AI专家。",
//       "path": "https://isc.360.com/new/2024/event/camp.html"
//     },
//     {
//       "id": 1,
//       "pcPhoto": "https://p5.ssl.qhimg.com/t110b9a93013933ef4ba1071a96.png",
//       "mobilePhoto": "https://p5.ssl.qhimg.com/t110b9a930111c5dda723854486.png",
//       "title": "大会售票",
//       "detail": "ISC.AI 2024第十二届互联网安全大会将于7月31日至8月1日在北京国家会议中心开启巨幕。大会已正式开启早鸟抢票通道，包括学生票，单日票、双日通票、VIP贵宾票，最高优惠直降4000，限量发售！",
//       "path": "https://isc.360.com/2024/ticket"
//     },
//     {
//       "id": 2,
//       "pcPhoto": "https://p1.ssl.qhimg.com/t110b9a9301a5d19a9b6779d7bc.png",

//       "mobilePhoto": "https://p2.ssl.qhimg.com/t110b9a9301332e908142e3f1be.png",
//       "title": "议题征集",
//       "detail": "ISC.AI 2024致力于通过全球智库的思想交融，不断迸发出新对话、新探讨与新碰撞。此次大会面向全球同步展开AI和安全两大赛道的议题征集活动。",
//       "path": "https://isc.360.com/new/2024/event/signup.html"
//     },
//     {
//       "id": 3,
//       "pcPhoto": "https://p2.ssl.qhimg.com/t110b9a9301bdccf1c1906c805d.png",

//       "mobilePhoto": "https://p1.ssl.qhimg.com/t110b9a93017f3a4ea6739c73f7.png",
//       "title": "沙盒大赛",
//       "detail": "ISC.AI 2024创新独角兽沙盒大赛以创新为唯一评判标尺，首次推出数字安全、AI应用以及ISC沙盒新星三大赛道，旨在深入探索创新机遇，挖掘并孵化AI时代下的创新独角兽。",
//       "path": "https://isc.360.com/new/2024/event/sandbox.html"
//     }
//   ],
//   "partner": [
//     {
//       "title": "全面战略合作伙伴",
//       "pcPhotos": ["https://p0.qhimg.com/t11098f6bcd9511112e890335e3.png"],
//       "mobilePhotos": ["https://p0.qhimg.com/t11098f6bcd12bf6f5bf343e88e.png"]
//     },
//     {
//       "title": "战略合作伙伴",
//       "pcPhotos": [
//         "https://p0.qhimg.com/t11098f6bcdce277af1a40c1b1c.png",
//         "https://p0.qhimg.com/t11098f6bcd74488347464c50c5.png",
//         "https://p0.qhimg.com/t11098f6bcdbece2fc34c4cd9af.png",
//         "https://p0.qhimg.com/t11098f6bcd24ae47c650b1b843.png",
//         "https://p0.qhimg.com/t11098f6bcdde754ae5b802603f.png"
//       ],
//       "mobilePhotos": [
//         "https://p0.qhimg.com/t11098f6bcd0971f525744a0369.png",
//         "https://p0.qhimg.com/t11098f6bcdaeb57f49da329527.png",
//         "https://p0.qhimg.com/t11098f6bcd7652829ce6aef970.png",
//         "https://p0.qhimg.com/t11098f6bcd8397c45b9853fae8.png",
//         "https://p0.qhimg.com/t11098f6bcd31dcff147d1dd4d1.png"
//       ]
//     },
//     {
//       "title": "钻石合作伙伴",
//       "pcPhotos": [
//         "https://p0.qhimg.com/t11098f6bcddfbb03fc401b6333.png",
//         "https://p0.qhimg.com/t11098f6bcddd9246d8f42cfc56.png",
//         "https://p0.qhimg.com/t11098f6bcd38733b48607cb334.png",
//         "https://p0.qhimg.com/t11098f6bcd526a6cc76ba0c977.png"
//       ],
//       "mobilePhotos": [
//         "https://p0.qhimg.com/t11098f6bcd20e3fbdc2499654e.png",
//         "https://p0.qhimg.com/t11098f6bcdde2b3a8825c43df4.png",
//         "https://p0.qhimg.com/t11098f6bcddfa09f650dca2fe6.png",
//         "https://p0.qhimg.com/t11098f6bcd144c63dc87189142.png"
//       ]
//     },
//     {
//       "title": "铂金合作伙伴",
//       "pcPhotos": ["https://p0.qhimg.com/t11098f6bcd32979971c2fe8fda.png"],
//       "mobilePhotos": ["https://p0.qhimg.com/t11098f6bcda909aa04bb2ac09b.png"]
//     },
//     {
//       "title": "黄金合作伙伴",
//       "pcPhotos": [
//         "https://p0.qhimg.com/t11098f6bcd8fa5ed7c465519c3.png",
//         "https://p0.qhimg.com/t11098f6bcd1b82b057d0dd872f.png",
//         "https://p0.qhimg.com/t11098f6bcde7886f5857c4d69f.png"
//       ],
//       "mobilePhotos": [
//         "https://p0.qhimg.com/t11098f6bcd244bbade4d777e2e.png",
//         "https://p0.qhimg.com/t11098f6bcd743f5de482f49ef7.png",
//         "https://p0.qhimg.com/t11098f6bcd671af3069928153c.png"
//       ]
//     },
//     {
//       "title": "标准合作伙伴",
//       "pcPhotos": [
//         "https://p0.qhimg.com/t11098f6bcd3a3a5bf8818cb711.png",
//         "https://p0.qhimg.com/t11098f6bcdc617461beb2769b6.png",
//         "https://p0.qhimg.com/t11098f6bcd33e9b249f0fb6a55.png",
//         "https://p0.qhimg.com/t11098f6bcd16aac09d58e1924e.png",
//         "https://p0.qhimg.com/t11098f6bcd457c0d051f82fdf2.png",
//         "https://p0.qhimg.com/t11098f6bcd66c246481e7ab48a.png",
//         "https://p0.qhimg.com/t11098f6bcd7c31ed9b020dd229.png",
//         "https://p0.qhimg.com/t11098f6bcd78ae99844745becc.png",
//         "https://p0.qhimg.com/t11098f6bcd26d788fc9311f150.png",
//         "https://p0.qhimg.com/t11098f6bcdb94efcda6e1f926a.png",
//         "https://p0.qhimg.com/t11098f6bcda5971f68ee7ee06a.png",
//         "https://p0.qhimg.com/t11098f6bcd7a7e45825cf93635.png",
//         "https://p0.qhimg.com/t11098f6bcd11a030b0db9800d1.png",
//         "https://p0.qhimg.com/t11098f6bcdf047bd4d5e1fd663.png",
//         "https://p0.qhimg.com/t11098f6bcd3422ac5d60c38f38.png"
//       ],
//       "mobilePhotos": [
//         "https://p0.qhimg.com/t11098f6bcd2e771ba64649a90c.png",
//         "https://p0.qhimg.com/t11098f6bcddde3268e5337379a.png",
//         "https://p0.qhimg.com/t11098f6bcd73bc5cc4e6495f1f.png",
//         "https://p0.qhimg.com/t11098f6bcd5ac1638bdad8c9e3.png",
//         "https://p0.qhimg.com/t11098f6bcd311994fe8b2a4a84.png",
//         "https://p0.qhimg.com/t11098f6bcd51b8457e6cb7e6ba.png",
//         "https://p0.qhimg.com/t11098f6bcd3064db7c53d0f0aa.png",
//         "https://p0.qhimg.com/t11098f6bcd2441b06a3d34b74b.png",
//         "https://p0.qhimg.com/t11098f6bcd3208f0d6b0f227c1.png",
//         "https://p0.qhimg.com/t11098f6bcdc82198d37033123e.png",
//         "https://p0.qhimg.com/t11098f6bcd57314c8a49e7c38b.png",
//         "https://p0.qhimg.com/t11098f6bcd806fec99f243d2cd.png",
//         "https://p0.qhimg.com/t11098f6bcd4ed7df36371d0390.png",
//         "https://p0.qhimg.com/t11098f6bcdde7571e33e97b8c8.png",
//         "https://p0.qhimg.com/t11098f6bcdb00a233f47b3cb33.png"
//       ]
//     },
//     {
//       "title": "媒体合作伙伴",
//       "pcPhotos": [
//         "https://p1.ssl.qhimg.com/t110b9a93016e50d06799e7228e.png",
//         "https://p1.ssl.qhimg.com/t110b9a9301534d1af1634cdbaa.png",
//         "https://p3.ssl.qhimg.com/t110b9a9301d7e471066ad6ef79.png",
//         "https://p0.ssl.qhimg.com/t110b9a9301eeb86e8e41e2d300.png",
//         "https://p4.ssl.qhimg.com/t110b9a93013a43efd089d7b730.png",
//         "https://p3.ssl.qhimg.com/t110b9a93010da7b3e689820d1a.png",
//         "https://p2.ssl.qhimg.com/t110b9a9301ec3a1c653b3ef36e.png",
//         "https://p1.ssl.qhimg.com/t110b9a9301a496326b6c2de19a.png",
//         "https://p0.ssl.qhimg.com/t110b9a9301060260158790ab99.png",
//         "https://p3.ssl.qhimg.com/t110b9a9301de653272ad27434b.png",
//         "https://p3.ssl.qhimg.com/t110b9a9301c35f752933ac1156.png",
//         "https://p4.ssl.qhimg.com/t110b9a9301e753e6e97542b332.png"
//       ],
//       "mobilePhotos": [
//         "https://p3.ssl.qhimg.com/t110b9a9301eeb2147f70372188.png",
//         "https://p2.ssl.qhimg.com/t110b9a9301f46f060c8ece7d6c.png",
//         "https://p1.ssl.qhimg.com/t110b9a93018980b4526b971f9f.png",
//         "https://p1.ssl.qhimg.com/t110b9a93010601be858759b7a1.png",
//         "https://p2.ssl.qhimg.com/t110b9a9301986f1aa0086d59c8.png",
//         "https://p4.ssl.qhimg.com/t110b9a93015b486690c49f8a58.png",
//         "https://p1.ssl.qhimg.com/t110b9a930194316a2f296202cf.png",
//         "https://p1.ssl.qhimg.com/t110b9a9301d34a20b929177410.png",
//         "https://p5.ssl.qhimg.com/t110b9a93017876b31e348097f1.png",
//         "https://p3.ssl.qhimg.com/t110b9a9301dba0306fc2c8d72f.png",
//         "https://p2.ssl.qhimg.com/t110b9a93018f4fe3b4728db8bf.png",
//         "https://p4.ssl.qhimg.com/t110b9a93013611b0968488422a.png"
//       ]
//     }
//   ]
// }
// )
const allData = ref({})

onBeforeMount(async () => {
  await fetch()
})

const fetch = () => {
  getRecruit('ejByNGJJeTVGMHQ2SlZQZ08wOFM4Zz09OjoNB4pxiex261nAViYKtsQ1')
    .then((res) => {
      allData.value = JSON.parse(res.data.data.data)
    })
    .catch(() => {})
}
</script>

<style lang="scss" scoped>
.body {
  position: relative;
  background-color: #f3f3f3;
  overflow: hidden;
}
</style>
